import i18n from 'i18n-js';
import { Logger } from 'aws-amplify';

import Language, { Known } from '../../constants/localization';
import { Locale, Translations } from '../../constants/translation';

import legge from './legge';
import wilhelm from './wilhelm';
import common from '../common';

type BooksTranslation = { [locale: string]: { [name: string]: any } };

const logger = new Logger('book-translation');

const DefaultBookLocale = 'en';

// @todo map reduce books with their id into Books
const Books: BooksTranslation = {
  en: {
    Legge: legge.translation.en,
    Wilhelm: wilhelm.translation.en
  },
  es: {
    Wilhelm: wilhelm.translation.es
  }
};

export const nearest = (locale: Locale): string =>
  locale === 'es' ? 'Wilhelm' : 'Legge';

export const list = (locale: Locale): string[] => {
  const r = Object.keys(Books[locale]);

  return r;
};

export const translationBook = (
  name: string | null,
  locale: Locale
): { name: string; book: any } => {
  const unknownLocale = !Known.includes(locale);

  if (unknownLocale)
    logger.debug(
      `unknown locale ${locale}, switching to default book ${DefaultBookLocale} locale`
    );

  // Default book lang, prevails over the UI one, @todo reconsider
  const localeBooks = Books[unknownLocale ? DefaultBookLocale : locale];

  if (!localeBooks)
    logger.warn(
      `unknown books for locale ${locale}, switching to nearest book ${nearest(
        locale
      )}`
    );

  if (!name)
    logger.warn(
      `unknown books for locale ${locale}, no translation name specified, switching to nearest book ${nearest(
        locale
      )}`
    );

  const finalName =
    (name && localeBooks[name] && name) ||
    nearest(locale) ||
    nearest(DefaultBookLocale);

  if (localeBooks && !localeBooks[finalName])
    logger.warn(
      `unknown translation for locale ${locale} and book ${finalName}, locale books are ${JSON.stringify(
        Object.keys(localeBooks)
      )}`
    );

  const result = { name: finalName, book: localeBooks[finalName] };
  logger.info(`Obtained ${result.name} as the book translation for ${locale}`);

  return result;
};

export const translation = (
  name: string | null,
  locale: Locale
): Translations => translationBook(name, locale).book;

export const summary = (): {} => {
  // @todo map reduce over Book[locale]
  const r = {
    en: {
      translations: {
        Legge: {
          authors: legge.translation.en.authors,
          rights: legge.translation.en.rights
        },
        Wilhelm: {
          authors: wilhelm.translation.en.authors,
          rights: wilhelm.translation.en.rights
        }
      }
    },
    es: {
      translations: {
        Wilhelm: {
          authors: wilhelm.translation.es.authors,
          rights: wilhelm.translation.es.rights
        }
      }
    }
  };

  return r;
};

export const updateTranslations = (updated: string | null) => {
  const books: Translations = summary();
  logger.info(
    `To update to ${updated} book translation, known books ${JSON.stringify(
      books
    )}}`
  );
  i18n.translations = {
    es: {
      ...common.es,
      ...translation(updated, 'es'),
      ...books.es
    },
    en: {
      ...common.en,
      ...translation(updated, 'en'),
      ...books.en
    }
  };

  i18n.locale = Language.locale();
  i18n.fallbacks = false;
};
